import { http } from 'http';

export default {
  patchOperation: ({ guid, operations }) =>
    http.patch(`/operations/${guid}`, operations, {
      headers: {
        'content-type': 'application/json-patch+json'
      }
    }),
  saveHolderMobile: ({ operationGuid, newMobile }) =>
    http.patch(`/operations/${operationGuid}`, newMobile, {
      headers: {
        'content-type': 'application/json-patch+json'
      }
    })
};
